module.exports = __webpack_public_path__ + "img/hekokuLaravel.56802e7a.jpeg";